import { AppInsightsClient } from '@axa-asia/app-insights-client';
import { getAxaIdFromUrl, getClientIdFromUrl, getGa4ClientIdFromUrl } from './analytics';
import { getAxaIdByJwtToken } from './common-functions';
import config from '../config';

/** Call to start app insight */
export const startAppInsight = () => {
    const instrumentationKey = config.appInsightsInstrumentationKey;
    if (instrumentationKey) {
        const ga4ClientId = getGa4ClientIdFromUrl() || '';
        const axaId = getAxaIdByJwtToken() || getAxaIdFromUrl();
        const platform = (config.isApp) ? 'app' : 'web-portal';
        const app = 'iam-fe';
        const instance = AppInsightsClient.getInstance();
        instance.init({
            instrumentationKey,
            axaId,
            ga4ClientId,
            app,
            platform,
            captureCaughtError: config.appInsightsCaptureCaughtError,
            disableConsoleLog: config.appInsightsDisableConsoleLog,
          });
    }
}